/*
 * @Author: Cphayim
 * @Date: 2020-03-14 17:38:09
 * @LastEditTime: 2020-10-21 10:51:33
 * @Description: 配置文件
 */
import { ENVS } from './envs'
import { SERVICES } from './services'

export default {
  ENVS,
  SERVICES,
}
